/* istanbul ignore file */
import { useEffect } from 'react';
import useUploadToS3 from 'src/hooks/useUploadToS3';
import { ProgressBar } from 'src/shared-components';
import VideoCapture from 'src/shared-components/VideoCapture/VideoCapture';

const WIDTH = 464;
const HEIGHT = 261;
const RECORD_TIMER_SECONDS_LIMIT = process.env.RECORD_TIMER_SECONDS_LIMIT as unknown as number;

const VideoUploader = ({ onVideoUploaded }: { onVideoUploaded: (url: string) => void }) => {
  const { upload, url, status, error, progress } = useUploadToS3();

  const handleUploadToS3 = (blob: Blob) => {
    upload(blob, 'video/mp4');
  };

  useEffect(() => {
    if (url) {
      onVideoUploaded(url);
    }
  }, [url]);

  useEffect(() => {
    if (error) {
      console.log(error);
    }
  }, [error]);

  return (
    <>
      {status === 'pending' ? (
        <div className="relative bg-gray-100 flex items-center justify-center" style={{ width: WIDTH, height: HEIGHT }}>
          <div className="w-5/12 text-center">
            <div>Your video is uploading</div>
            <div className="text-xs w-10/12 m-auto mt-1 text-gray-500">
              This could take a few minutes, please wait...
            </div>
            <ProgressBar progress={progress} />
          </div>
        </div>
      ) : (
        <VideoCapture
          onVideoSent={handleUploadToS3}
          width={WIDTH}
          height={HEIGHT}
          timeLimit={RECORD_TIMER_SECONDS_LIMIT}
        />
      )}
      {/* {url}
      {error} */}
    </>
  );
};

export default VideoUploader;
